import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    issueDetailWrapper: {
        display: "flex",
        minHeight: "calc(100vh - 64px)",
    },
    leftContainer: {
        display: "flex",
        flexDirection: "column",
        flex: "75% 0 0",
    },
    rightContainer: {
        flex: "25% 0 0",
        backgroundColor: theme.palette.primary.main,
        boxShadow: `0px 2px 9px 0px ${theme.palette.dropShadows.main}`,
        padding: `${theme.spacing(11.25)} ${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(4)}`,
    },
    backButton: {
        "&.MuiButtonBase-root": {
            fontFamily: "Open Sans",
            fontWeight: 400,
            fontSize: "12px",
            color: theme.palette.text.primary,
            padding: 0,
            textTransform: "uppercase",
        },
        "&.MuiButtonBase-root .MuiSvgIcon-root": {
            fontSize: "12px",
        },
    },
    ticketNumber: {
        marginTop: `${theme.spacing(3.5)} !important`,
    },
    issueTitle: {
        fontFamily: "Open Sans",
        fontSize: 24,
        marginTop: theme.spacing(3),
    },
    divider: {
        marginTop: `${theme.spacing(4)} !important`,
        marginBottom: `${theme.spacing(4)} !important`,
    },
    card: {
        marginTop: `${theme.spacing(6)} !important`,
    },
    cardContent: {
        padding: `${theme.spacing(4)} !important`,
    },
    issueDetailWrapperNoData: {
        display: "flex",
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "16px",
        fontFamily: "Open Sans",
        fontWeight: 700,
        color: theme.palette.primary.dark,
        gap: theme.spacing(2),
    },
    noDataIcon: {
        color: theme.palette.primary.dark,
    },
    tableCellCustomStyle: {
        padding: `${theme.spacing(4)} ${theme.spacing(2)} !important`,
    },
    iconWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 48,
        height: 48,
        borderRadius: "100%",
        backgroundColor: theme.palette.secondary.main,
    },
    icon: {
        color: theme.palette.info.light,
    },
    documentFilesWrapper: {
        marginTop: theme.spacing(10),
        marginBottom: theme.spacing(10),
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
        gap: theme.spacing(12),
    },
    documentFileWrapper: {
        display: "flex",
        gap: theme.spacing(2),
        alignItems: "center",
        fontFamily: "Open Sans",
        fontSize: "14px",
    },
    mediaFilesWrapper: {
        marginTop: "15px",
        marginBottom: "15px",
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: theme.spacing(7.5, 10),
    },
    mediaFile: {
        objectFit: "cover",
        width: "100%",
        height: "306px",
    },
    mediaLegend: {
        margin: 0,
        fontSize: "12.5px",
        fontFamily: "Open Sans",
        color: theme.palette.primary.darker,
    },
    mediaLink: {
        textDecoration: "none",
    },
    progressWrapper: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
        marginBottom: theme.spacing(4),
        fontFamily: "Open Sans",
        fontSize: "14px",
        color: theme.palette.info.main,
    },
    form: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(8),
    },
    datePicker: {
        width: "100%",
    },
    formItemDivider: {
        width: "100%",
    },
    headerActions: {
        display: "flex",
        justifyContent: "space-between",
    },
    disabledDropdown: {
        "& div": {
            WebkitTextFillColor: "unset !important",
        },
        "&.Mui-disabled .MuiSelect-icon": {
            display: "none",
        },
    },
}));
